module.exports = __webpack_public_path__ + "img/sidebar.275ea4e9.jpg";